import { createSelector } from 'reselect'
import config from 'config'

const qsSelectorState = state => state.qs
const flocabularySelector = state => state.flocabulary

const videoSelector = createSelector(
	[flocabularySelector, qsSelectorState],
	(flocabulary, qsSelectorData) => {
		const currentVideo = flocabulary.videos.find(video => video.contentId === flocabulary.selectedVideoId)
		const externalSource = currentVideo ? `${config.flocabulary_url}unit/${currentVideo.contentId}/standalone?jwt=${qsSelectorData.authId}` : ''
		return {
			externalSource,
		}
	}
)

export default videoSelector
